require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-join-us-for-our-legal-sector-event-on-18th-september-2019.json") })
        }
      }, "path---blog-join-us-for-our-legal-sector-event-on-18th-september-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-join-us-for-our-legal-sector-event-on-18th-september-2019!./.cache/json/blog-join-us-for-our-legal-sector-event-on-18th-september-2019.json
// module id = 830
// module chunks = 231608221292675